// Statuses that mean the employee has left (hidden unless "Show separated employees")
export const SEPARATED = ["resigned", "terminated", "deceased", "awol"];

export const isSeparated = (status) =>
  SEPARATED.includes(String(status || "").toLowerCase());

/** "Dela Cruz, Juan P." */
export const allocationName = (e) => {
  if (!e) return "—";
  const middle = e.middleName ? ` ${e.middleName.trim().charAt(0)}.` : "";
  const first = `${e.firstName || ""}${middle}`.trim();
  return [e.lastName, first].filter(Boolean).join(", ") || "—";
};

/** Badge tone for an employee status. */
export const statusTone = (status) => {
  const s = String(status || "").toLowerCase();
  if (isSeparated(s)) return "gray";
  if (s === "active" || s === "validated") return "green";
  return "amber"; // probation, incomplete, notice period...
};

/* ---------- Anniversary cycles (same rules as the backend) ---------- */
const pad = (n) => String(n).padStart(2, "0");
const isLeap = (y) => (y % 4 === 0 && y % 100 !== 0) || y % 400 === 0;

/** The hiring anniversary in a given year; Feb 29 hires use Feb 28 in non-leap years. */
const anniversaryIn = (month, day, year) =>
  `${year}-${pad(month)}-${pad(month === 2 && day === 29 && !isLeap(year) ? 28 : day)}`;

/** Day before a plain YYYY-MM-DD date. */
const dayBefore = (ymd) => {
  const d = new Date(`${ymd}T00:00:00Z`);
  d.setUTCDate(d.getUTCDate() - 1);
  return d.toISOString().slice(0, 10);
};

/**
 * The anniversary cycle containing `asOf` (plain dates, no time zones):
 * { start, end } from the last anniversary to the day before the next.
 * null without a valid hiring date or before the hiring date.
 */
export const cycleContaining = (hiringDate, asOf) => {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(hiringDate || "");
  if (!m || !asOf || Number(m[1]) < 1900) return null;
  const hireYear = Number(m[1]);
  const month = Number(m[2]);
  const day = Number(m[3]);
  const year = Number(asOf.slice(0, 4));
  let start = anniversaryIn(month, day, year);
  if (start > asOf) start = anniversaryIn(month, day, year - 1);
  if (Number(start.slice(0, 4)) < hireYear) return null;
  const nextStart = anniversaryIn(month, day, Number(start.slice(0, 4)) + 1);
  return { start, end: dayBefore(nextStart) };
};
